$(function () {

  function close_popin($popin) {
    if ($popin === undefined) {
      $popin = $('.popin');
    }
    $popin.closest('.overlay').removeClass('show');
    //$('body, html').removeClass('no-scroll');
  }

  /**
   * Adds ways to close a popin
   */
  $('.overlay .popin').each(function () {
    const $popin = $(this),
      $overlay = $popin.closest('.overlay');

    if ($popin.find('.cross').length) {

      // TODO: Test if it's useful or critical

      $overlay.on('click', function (e) {
        // if(!$(e.target).closest('.popin').length != 0) close_popin()
      });

      $(document).on('keyup', function (e) {
        if (e.keyCode == 27 && $overlay.hasClass('show')) {
          close_popin($popin);
        }
      });
    }
  });

  $('.close-overlay').on('click', function () {
    close_popin($(this))
  });

  $('.shoverlay').on('click', function () {
    if (!$(this).hasClass('locked')) {
      show_popin($('.overlay[data-popin="' + $(this).data('popin') + '"]'));
    }
  });


  function show_popin ($popin) {
    $popin.addClass('show');
    //$('body, html').addClass('no-scroll');
  }

  window.Anatec = window.Anatec || {};
  window.Anatec.popin = {
    show: show_popin,
    close: close_popin
  }

});